import { sectionCards } from "@/mocks/leakHome";

export default function SectionGrid() {
  return (
    <section id="sections" className="w-full bg-white py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-bold tracking-widest text-red-500">CHANNELS</p>
          <h2 className="mt-1 text-2xl font-black text-stone-800 md:text-3xl">热门分区，各聊各的瓜</h2>
          <p className="mt-2 text-sm text-stone-500">
            想蹲哪种，就去哪种分区。投稿也能选边，不愁没人接。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {sectionCards.map((card) => (
            <a
              key={card.id}
              href="#feed"
              className="group relative block h-72 overflow-hidden rounded-2xl"
            >
              <img
                src={card.cover}
                alt={`${card.name} 52爆料分区`}
                title={`${card.name} - 52爆料投稿`}
                className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
              />
              <div
                className={`absolute inset-0 bg-gradient-to-t ${card.accent} opacity-90`}
              ></div>
              <div className="absolute inset-x-0 bottom-0 p-4 text-white">
                <p className="text-[10px] font-bold tracking-[0.2em] text-white/70">{card.en}</p>
                <h3 className="mt-1 text-lg font-black">{card.name}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-white/85">
                  {card.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold backdrop-blur-sm">
                  <i className="ri-dashboard-3-line"></i> {card.count}
                </span>
              </div>
              <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-red-600 opacity-0 transition group-hover:opacity-100">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}